import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Fiat, FiatWallet } from "@models";
import { FiatDepositModalComponent } from "../../step-summary/fiat-transactions/fiat-deposit-modal/fiat-deposit-modal.component";
import { FiatService } from "@main-services/currency/fiat.service";
import { AccountService } from "@modules/account/services/account.service";
import { FiatTransaction } from "@models/transaction";
import { NotAvailableModalComponent } from "@modules/core/components/not-available-modal/not-available-modal.component";
import { ModalService } from "@core-services/modal.service";

@Component({
	selector: "fiat-wallet-tile",
	templateUrl: "./fiat-wallet-tile.component.html",
	styleUrls: ["./fiat-wallet-tile.component.scss"],
	standalone: false
})
export class FiatWalletTileComponent {
	@Input()
	public wallet: FiatWallet = null;
	@Input()
	public css: string = "";
	@Input()
	public active: boolean = false;
	@Input()
	public options: boolean = false;

	@Input()
	public pendingCounter: boolean = false;

	@Output()
	public onSelect = new EventEmitter<FiatWallet>();

	public constructor(
		private accountService: AccountService,
		private fiatService: FiatService,
		private modalService: ModalService
	) {}

	public deposit(): void {
		const f = new FiatTransaction();
		f["preselected"] = this.wallet;
		this.modalService
			.create(FiatDepositModalComponent, { data: { transaction: f } }, { showCloseButton: false })
			.present();
	}

	public walletDetails(): void {
		this.modalService.showModal(NotAvailableModalComponent);
	}

	public onClick(event): void {
		this.onSelect.emit(this.wallet);
	}

	public get fiat(): Fiat {
		return this.fiatService.getItemById(this.wallet.getFiatId());
	}

	public isDefaultFiat(): boolean {
		return this.fiat?.getId() === this.defaultFiat().getId();
	}

	public defaultFiat(): Fiat {
		return this.accountService.getDefaultFiat();
	}

	public toDefaultFiat(): number {
		if (!this.fiat) {
			return 0;
		}
		return (this.wallet.getBalance() * this.fiat.toEuroRate()) / this.defaultFiat().toEuroRate();
	}

	public getTransactionCounter(wallet: FiatWallet): boolean {
		if (wallet) {
			if (this.pendingCounter) {
				return wallet.getPendingTransactionCount() > 0;
			}
		}

		return false;
	}
}
